import React from 'react';
import PropTypes from 'prop-types';

import { useAppContext } from '@/context';
import SearchResultCard from './component';
import { hasRegistrationPerks } from '../../../../utils/race';

/**
 * Search card logical container.
 *
 */
class SearchResultCardContainer extends React.Component {
  getThumbnailUrl = (event) => {
    let optimizedUrl =
      event.images && event.images.hero && event.images.hero.medium
        ? event.images.hero.medium
        : null;
    optimizedUrl = optimizedUrl && optimizedUrl.replace(/w_512/g, 'h_140');
    if (optimizedUrl.includes('StubHeader')) return null;
    return optimizedUrl;
  };

  render() {
    const {
      onClick,
      active,
      elementRef,
      onMouseEnter,
      onMouseLeave,
      context,
    } = this.props;
    const {
      id,
      title,
      location,
      permalink,
      startDate,
      startDay,
      startMonth,
      place,
      races,
      reviewSummary,
      tags,
    } = this.props.event;
    if (this.props.data && this.props.data.loading) {
      return null;
    }

    const racesSummary = this.props.event && this.props.event.races;
    const searchResultsProps = {
      title,
      location,
      startDate,
      startDay,
      startMonth,
      place,
      races,
      permalink,
      countryCode: context?.COUNTRY_CODE,
      eventId: id,
      reviewSummary,
      hasRegistrationPerks: hasRegistrationPerks(racesSummary),
      thumbnailUrl: this.getThumbnailUrl(this.props.event),
      onClick,
      active,
      elementRef,
      onMouseEnter,
      onMouseLeave,
      showCovid19Badge: tags.indexOf('covid-19') !== -1,
    };

    return <SearchResultCard {...searchResultsProps} />;
  }
}

SearchResultCardContainer.propTypes = {
  event: PropTypes.shape().isRequired,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
};

SearchResultCardContainer.defaultProps = {
  onMouseEnter: () => {},
  onMouseLeave: () => {},
};

const SearchResultCardContainerWithContext = (props) => {
  const context = useAppContext();
  return <SearchResultCardContainer {...props} context={context} />;
};

export default SearchResultCardContainerWithContext;
